<template>
  <div>
    <!-- 积分概览卡片 -->
    <el-card>
      <div class="overview">
        <div>
          <div class="ov-label">當前積分</div>
          <div class="ov-points">{{ points }}</div>
          <div class="muted" style="font-size: 13px">每張圖 {{ rules.per_image }} 積分 · 影片每秒 {{ rules.per_second }} 積分</div>
        </div>
        <div class="ov-right">
          <!-- 「去儲值」已移除：平台未接支付，客户端不能自助充值。
               儲值请联系客服，由管理员在后台操作。 -->
          <div class="muted" style="font-size: 12px">1 元 = {{ rules.cny_rate }} 積分 · 每張圖 {{ rules.per_image }} 積分 · 影片每秒 {{ rules.per_second }} 積分</div>
          <div class="muted" style="font-size: 12px; margin-top:4px">需要儲值請聯繫客服，由管理員在後台為你儲值</div>
        </div>
      </div>
    </el-card>

    <!-- 明细 -->
    <el-card class="mt16">
      <el-tabs v-model="tab">
        <el-tab-pane label="積分明細" name="trans">
          <el-table :data="transactions" size="mini" empty-text="暫無明細">
            <el-table-column prop="created_at" label="時間" width="160" />
            <el-table-column label="類型" width="110">
              <template slot-scope="s">{{ typeLabel(s.row.type) }}</template>
            </el-table-column>
            <el-table-column label="積分" width="100">
              <template slot-scope="s">
                <span :class="s.row.points >= 0 ? 'plus' : 'minus'">
                  {{ s.row.points >= 0 ? '+' : '' }}{{ s.row.points }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="說明" />
          </el-table>
          <el-pagination
            v-if="transTotal > pageSize"
            background
            style="margin-top:10px;text-align:right"
            layout="prev, pager, next"
            :total="transTotal"
            :page-size="pageSize"
            @current-change="loadTrans"
          />
        </el-tab-pane>
        <el-tab-pane label="儲值記錄" name="recharge">
          <el-table :data="recharges" size="mini" empty-text="暫無儲值記錄">
            <el-table-column prop="created_at" label="時間" width="160" />
            <el-table-column prop="order_no" label="訂單號" width="180" />
            <el-table-column prop="amount_cny" label="金額(元)" width="100" />
            <el-table-column prop="points" label="獲得積分" />
            <el-table-column label="狀態" width="90">
              <template slot-scope="s"><el-tag size="mini" type="success">{{ s.row.status === 'paid' ? '已到帳' : s.row.status }}</el-tag></template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="rechargeTotal > pageSize"
            background
            style="margin-top:10px;text-align:right"
            layout="prev, pager, next"
            :total="rechargeTotal"
            :page-size="pageSize"
            @current-change="loadRecharges"
          />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { fetchBalance, fetchTransactions, fetchRecharges } from '../api/user'

export default {
  name: 'Profile',
  data() {
    return {
      tab: 'trans',
      points: 0,
      rules: { per_image: 10, per_second: 2, cny_rate: 10 },
      transactions: [],
      transTotal: 0,
      recharges: [],
      rechargeTotal: 0,
      pageSize: 15
    }
  },
  created() {
    this.loadAll()
  },
  methods: {
    // goRecharge() 已移除：客户端不再支持自助充值（平台未接支付），
    // 「去儲值」按钮也已从余额卡片上拿掉。儲值由管理员在后台操作。
    async loadAll() {
      try {
        const b = await fetchBalance()
        this.points = b.points
        this.rules = { per_image: b.per_image, per_second: b.per_second,
          cny_rate: b.cny_rate || 10 }
      } catch (e) { /* token 失效由拦截器处理 */ }
      this.loadTrans(1)
      this.loadRecharges(1)
    },
    async loadTrans(page) {
      try {
        const d = await fetchTransactions({ page, pageSize: this.pageSize })
        this.transactions = d.list
        this.transTotal = d.total
      } catch (e) { /* ignore */ }
    },
    async loadRecharges(page) {
      try {
        const d = await fetchRecharges({ page, pageSize: this.pageSize })
        this.recharges = d.list
        this.rechargeTotal = d.total
      } catch (e) { /* ignore */ }
    },
    typeLabel(t) {
      const map = { recharge: '儲值', consume_image: '生成圖片', consume_video: '生成影片' }
      return map[t] || t || '其他'
    }
  }
}
</script>

<style scoped>
.overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ov-label {
  color: var(--c-text-3);
  font-size: 13px;
}
.ov-points {
  font-size: 40px;
  font-weight: 700;
  color: var(--c-primary-ink);
  line-height: 1.2;
}
.ov-right {
  text-align: right;
}
.muted { color: var(--c-text-3); }
.plus { color: var(--c-primary-ink); font-weight: 600; }
.minus { color: var(--c-danger); font-weight: 600; }
.mt16 { margin-top: 16px; }
.mt10 { margin-top: 10px; }
</style>
